import React, { useCallback } from 'react';
import { Button, Card, Checkbox, Col, Input, Row, Switch, Tooltip, Typography } from "antd";
import { StyleSheet } from "../../../StyleSheet";
import { CloseOutlined, EditOutlined, InfoCircleOutlined, LeftOutlined, MinusOutlined, RightOutlined, SaveOutlined } from '@ant-design/icons';
import _ from 'lodash';
import { images } from '../../../routes/ImageRoutes';
import { CheckboxChangeEvent } from 'antd/es/checkbox';
import { Link } from 'react-router-dom';
import SwipeableButton from '../../../components/SwipeableButton';
import moment from "moment";
import DisabledSwipeableButton from '../../../components/DisabledSwipeableButton';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../stores/store';
import { AlertSliceInterface, clearAlert, setAlert, showAlert } from '../../../stores/slices/alertSlice';
import { ResponseSuscriptorDataGeneralDatum } from '../../../types/common';
const { Text } = Typography;

interface InfoCardProps {
    cardNumSaved: string;
    dataClient?: ResponseSuscriptorDataGeneralDatum;
    doPayment: (cardDataToPay: CardPaymentProps | null) => void;
    updateCard: (cardNumToUpdate: string) => void;
}

interface errorFieldsProps {
    creditCard: string,
    expirationCard?: string,
    cvvCard?: string,
    expirationCardSaved?: string
    cvvCardSaved?: string
}

export interface CardPaymentProps {
    number: string,
    cvvCard: string,
    expirationDateCard: string,
    toSaveCard: boolean,
    isNewCard: boolean
}

const PaymentCardData = (props: InfoCardProps) => {
    const emptyErrorFields: errorFieldsProps = {
        creditCard: "",
        expirationCard: "",
        cvvCard: ""
    }
    const { cardNumSaved, dataClient, doPayment, updateCard } = props;
    const [cardNumToUpdate, setCardNumToUpdate] = React.useState("");
    const [numCardNew, setNumCardNew] = React.useState("");
    const [cvvCardNew, setCvvCardNew] = React.useState("");
    const [expCardNew, setExpCardNew] = React.useState("");
    const [expCardSaved, setExpCardSaved] = React.useState("");
    const [cardEnd, setCardEnd] = React.useState("");
    const [cvvCardSaved, setCvvCardSaved] = React.useState("");
    const [toSaveCard, setToSaveCard] = React.useState(false);
    const [editingCard, setEditingCard] = React.useState(false);
    const [cardToPay, setCardToPay] = React.useState<CardPaymentProps | null>(null);
    const [payWithThisCard, setPayWithThisCard] = React.useState(false);
    const [payWithOtherCard, setPayWithOtherCard] = React.useState(false);
    const [desplegable, setDesplegable] = React.useState(false);
    const [confirmStep, setConfirmStep] = React.useState<boolean>(false);
    const [checked, setChecked] = React.useState<boolean>(false);
    const dispatch = useDispatch<AppDispatch>();
    const [errorsEmptyFields, setErrorsEmptyFields] = React.useState<errorFieldsProps>(emptyErrorFields);

    const handleDispatchAlertModal = useCallback(() => {
        dispatch(showAlert(false));
        dispatch(clearAlert());
    }, [dispatch]);

    const openAlertModal = useCallback((option: AlertSliceInterface) => {
        dispatch(setAlert({
            show: option.show,
            type: option.type as "INFO" | "SUCCESS" | "ERROR",
            title: option.title,
            message: option.message,
            extraComponents: option.extraComponents,
            onFinalize: option.onFinalize
        }));
    }, [dispatch]);

    const handleCvvCardSaved = (inputValue: string) => {
        errorsEmptyFields.cvvCard = "";
        setCvvCardSaved(inputValue.replace(/[^0-9]/g, ''));
    };

    const handleCardNumSaved = (inputValue: string) => {
        errorsEmptyFields.creditCard = "";
        var numberRaw = inputValue.split("-").join("");
        var numberFormated = inputValue.match(new RegExp('.{1,4}', 'g'))?.join("-");
        if (numberRaw.length <= 16) {
            if (numberFormated) {
                setCardNumToUpdate(numberFormated);
            } else {
                setCardNumToUpdate("");
            }
        }
    };

    const handleCardNumNew = (inputValue: string) => {
        errorsEmptyFields.creditCard = "";
        var numberRaw = inputValue.split("-").join("");
        var numberFormated = inputValue.match(new RegExp('.{1,4}', 'g'))?.join("-");
        if (numberRaw.length <= 16) {
            if (numberFormated) {
                setNumCardNew(numberFormated);
            } else {
                setNumCardNew("");
            }
        }
    };

    const handleCardCvvNew = (inputValue: string) => {
        errorsEmptyFields.cvvCard = "";
        const numericValue = inputValue.replace(/[^0-9]/g, '');
        setCvvCardNew(numericValue);
    };

    const handleCardExpNew = (inputValue: string) => {
        errorsEmptyFields.expirationCard = "";
        const numericValue = inputValue.replace(/[^0-9]/g, '');
        setExpCardNew(numericValue);
    };

    const handleExpCardNumSaved = (value: string) => {
        errorsEmptyFields.expirationCard = "";
        setExpCardSaved(value.replace(/[^0-9]/g, ''))
    }

    const onChange = (checked: boolean) => {
        setToSaveCard(checked)
    };

    const onChangeCheck = (e: CheckboxChangeEvent) => {
        setChecked(e.target.checked);
    };

    const validateData = () => {
        let messageField = "El campo está vacío.\n";
        var reg = new RegExp("(0[1-9]|1[012])/[0-9]{2}");
        let error = "";
        let hasErrorMMAA = true;
        let hasErrorCvv = true;

        let errorFields: errorFieldsProps = {
            creditCard: "",
            expirationCard: "",
            cvvCard: "",
            expirationCardSaved: "",
            cvvCardSaved: "",
        }

        if (payWithOtherCard) {
            let cardNumberLenght = numCardNew.match(/[0-9]/g)?.length;

            if (!cardNumberLenght || cardNumberLenght < 16) {
                let message = "La tarjeta debe tener 16 dígitos.\n";
                error += message;
                errorFields.creditCard = "Campo debe ser a 16 dígitos.";
            }
            if (!cvvCardNew) {
                let message = "El campo cvv está vacío.\n";
                error += message;
                errorFields.cvvCard = messageField;
            } else if (cvvCardNew.length < 3) {
                let message = "El campo debe ser a 3 dígitos.\n";
                error += message;
                errorFields.cvvCard = message;
            } else {
                hasErrorCvv = false;
            }
            if (!expCardNew) {
                let message = "El campo vencimiento está vacío.\n";
                error += message;
                errorFields.expirationCard = messageField;
            }
            else {
                let expDate = expCardNew.replace(/(\d{2})(\d{2})/, "$1/$2")
                if (reg.test(expDate))
                    hasErrorMMAA = false;
                else {
                    if (expDate.indexOf("/") < 0) {
                        let message = "El campo MM/AA es incongruente.\n";
                        error += message;
                        errorFields.expirationCard = message;
                    } else {
                        let message = "El campo Mes (MM) y/o año (AA) es incorrecto.\n";
                        error += message;
                        errorFields.expirationCard = message;
                    }
                }
                let mes = expDate.slice(0, 2);
                let mesActual = moment().format("MM");
                let anio = expDate.slice(3, 5);
                let anioActual = moment().format("YY");

                if (!_.isEmpty(anio) && !_.isEmpty(mes)) {
                    if (anio === anioActual && mes < mesActual) {
                        let message = "El mes de la tarjeta ha expirado.\n";
                        error += message;
                        errorFields.expirationCard = "El mes ha expirado.";
                    }
                    if (anio < anioActual) {
                        let message = "El año de la tarjeta ha expirado.\n";
                        error += message;
                        errorFields.expirationCard = "El año ha expirado.";
                    }
                }
            }
        } else {
            if (!expCardSaved) {
                let message = "El campo vencimiento está vacío.\n";
                error += message;
                errorFields.expirationCard = messageField;
            }
            else {
                let expDateSaved = expCardSaved.replace(/(\d{2})(\d{2})/, "$1/$2")
                if (reg.test(expDateSaved))
                    hasErrorMMAA = false;
                else {
                    if (expDateSaved.indexOf("/") < 0) {
                        let message = "El campo MM/AA es incongruente.\n";
                        error += message;
                        errorFields.expirationCard = "Formato inválido.";
                    } else {
                        let message = "El campo Mes (MM) y/o año (AA) es incorrecto.\n";
                        error += message;
                        errorFields.expirationCard = "Formato inválido.";
                    }
                }
                let mes = expCardSaved.slice(0, 2);
                let mesActual = moment().format("MM");
                let anio = expCardSaved.slice(2, 5);
                let anioActual = moment().format("YY");

                if (!_.isEmpty(anio) && !_.isEmpty(mes)) {
                    if (anio === anioActual && mes < mesActual) {
                        let message = "El mes de la tarjeta ha expirado.\n";
                        error += message;
                        errorFields.expirationCard = "El mes ha expirado.";
                    }
                    if (anio < anioActual) {
                        let message = "El año de la tarjeta ha expirado.\n";
                        error += message;
                        errorFields.expirationCard = "El año ha expirado.";
                    }
                }
            }
            if (!cvvCardSaved) {
                let message = "El campo cvv está vacío.\n";
                error += message;
                errorFields.cvvCard = messageField;
            } else if (cvvCardSaved.length < 3) {
                let message = "El campo CVV debe ser a 3 dígitos.\n";
                error += message;
                errorFields.cvvCard = "El campo es a 3 dígitos.";
            } else {
                hasErrorCvv = false;
            }

        }
        setErrorsEmptyFields(errorFields);
        if (error !== "") {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        }

        // Si cumple con todas las validaciones 
        if (!hasErrorMMAA && !hasErrorCvv && error === "") {
            setConfirmStep(true);
            let cardDataObj: CardPaymentProps;
            if (payWithOtherCard) {
                cardDataObj = {
                    // quita los guiones con los que se guardaba en el input
                    number: numCardNew.split("-").join(''),
                    cvvCard: cvvCardNew,
                    expirationDateCard: expCardNew,
                    isNewCard: cardNumSaved === "" ? true : false,
                    toSaveCard: false,
                }
                setCardEnd(cardDataObj.number.substring(12, 16))
            } else {
                cardDataObj = {
                    number: _.trim(cardNumSaved, '*'),
                    cvvCard: cvvCardSaved,
                    expirationDateCard: expCardSaved,
                    isNewCard: false,
                    toSaveCard: false,
                }
                setCardEnd(cardDataObj.number);
            }
            cardDataObj.isNewCard = cardNumSaved === "" ? true : false;
            cardDataObj.toSaveCard = toSaveCard;
            setCardToPay(cardDataObj);
        }
    }

    const closeUpdateCard = () => {
        setExpCardSaved("");
        setCvvCardSaved("");
        setCardNumToUpdate("");
        setEditingCard(false);
        setPayWithThisCard(false);
        setErrorsEmptyFields(emptyErrorFields);
    }

    const updateCardFnt = async () => {
        let error = "";
        let errorFields: errorFieldsProps = {
            creditCard: "",
        }

        let cardNumberLenght = cardNumToUpdate.match(/[0-9]/g)?.length;

        if (!cardNumberLenght || cardNumberLenght < 16) {
            let message = "La tarjeta debe tener 16 dígitos.\n";
            error += message;
            errorFields.creditCard = "El campo debe ser a 16 dígitos.";
        }

        setErrorsEmptyFields(errorFields);

        if (error !== "") {
            let dispatchAlert: AlertSliceInterface = {
                show: true,
                type: "ERROR",
                title: "¡Estimado Usuario!",
                message: error,
                onFinalize: () => handleDispatchAlertModal()
            }
            openAlertModal(dispatchAlert);
        } else {
            updateCard(cardNumToUpdate)
        }
    }

    const handlePayOther = () => {
        setDesplegable(!desplegable);
        setErrorsEmptyFields(emptyErrorFields);
        if (desplegable) {
            setNumCardNew("");
            setCvvCardNew("");
            setExpCardNew("");
            setPayWithOtherCard(false);
        } else {
            setPayWithOtherCard(true);
        }
    }

    return (
        <>
            {
                cardNumSaved && !payWithOtherCard && !confirmStep ?
                    <Card style={styles.cardViewRoot}>
                        <Row style={{ width: "100%" }}>
                            <Col xs={19}>
                                <div style={styles.textTitle}>{cardNumSaved}</div>
                            </Col>
                            <Col xs={5}>
                                {
                                    !editingCard && !confirmStep && !payWithThisCard ?
                                        <>
                                            <Row justify={"end"} gutter={[12, 12]}>
                                                <Col>
                                                    <EditOutlined style={styles.icon} onClick={() => setEditingCard(!editingCard)} />
                                                </Col>
                                                <Col>
                                                    <RightOutlined style={styles.icon} onClick={() => setPayWithThisCard(true)} />
                                                </Col>
                                            </Row>
                                        </>
                                        :
                                        <>
                                            <Row justify={"end"} gutter={[12, 12]}>
                                                {
                                                    editingCard ?
                                                        <Col>
                                                            <SaveOutlined style={styles.icon} onClick={updateCardFnt} />
                                                        </Col> : null
                                                }

                                                <Col>
                                                    <CloseOutlined style={styles.icon} onClick={closeUpdateCard} />
                                                </Col>
                                            </Row>
                                        </>
                                }
                            </Col>

                            {
                                editingCard ?
                                    <Col style={styles.colCardNumber}>
                                        <div style={styles.inputContainer}>
                                            <div style={styles.inputTitle}>Número de tarjeta</div>
                                            <Input
                                                value={cardNumToUpdate}
                                                style={styles.inputText}
                                                placeholder='0000 0000 0000 0000'
                                                onChange={(element) => handleCardNumSaved(element.target.value.replace(/[^0-9]/g, ''))}
                                                status={errorsEmptyFields.creditCard ? "error" : ""}
                                                maxLength={19}
                                            />
                                            {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.creditCard ? errorsEmptyFields.creditCard : null}</Text>}
                                        </div>
                                    </Col>
                                    : payWithThisCard ?
                                        <Row justify={"space-evenly"} style={styles.rowViewPaymentData} gutter={[12, 12]}>
                                            <Col xs={24} xl={10}>
                                                <Text style={styles.inputTitle}>Vencimiento</Text>
                                                <Input
                                                    value={expCardSaved.replace(/(\d{2})(\d{2})/, "$1/$2")}
                                                    style={styles.inputText}
                                                    placeholder='mm/aa'
                                                    onChange={(element) => handleExpCardNumSaved(element.target.value)}
                                                    status={errorsEmptyFields.expirationCard ? "error" : ""}
                                                    maxLength={5}
                                                    suffix={
                                                        <Tooltip title={`Fecha de vencimiento: Fecha ubicada al frente de tu tarjeta, debajo del número de tarjeta.`} >
                                                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                        </Tooltip>
                                                    }
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.expirationCard ? errorsEmptyFields.expirationCard : null}</Text>}
                                            </Col>
                                            <Col xs={24} xl={10}>
                                                <Text style={styles.inputTitle}>CVV</Text>
                                                <Input
                                                    value={cvvCardSaved}
                                                    style={styles.inputText}
                                                    placeholder='000'
                                                    onChange={(element) => handleCvvCardSaved(element.target.value)}
                                                    status={errorsEmptyFields.cvvCard ? "error" : ""}
                                                    maxLength={3}
                                                    suffix={
                                                        <Tooltip title={`CVV: Código de 3 dígitos, situado al reverso de tu tarjeta.`} >
                                                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                        </Tooltip>
                                                    }
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.cvvCard ? errorsEmptyFields.cvvCard : null}</Text>}
                                            </Col>
                                        </Row>
                                        :
                                        null
                            }
                        </Row>
                    </Card>
                    : null
            }
            {
                payWithThisCard ?
                    <>
                        {
                            !confirmStep ?
                                <Card
                                    onClick={validateData}
                                    style={styles.cardViewPay}
                                >
                                    <Row>
                                        <Col xs={22}>
                                            <Text style={styles.textTitle}>{"Pagar con esta tarjeta"}</Text>
                                        </Col>
                                        <Col xs={2} >
                                            <RightOutlined style={styles.icon} />
                                        </Col>
                                    </Row>
                                </Card>
                                :
                                null
                        }
                    </>
                    :
                    <>
                        {
                            !confirmStep && !editingCard ?
                                <Card style={styles.cardView}>
                                    <Row
                                        onClick={handlePayOther}
                                        style={{ cursor: 'pointer' }}
                                    >
                                        <Col xs={23}>
                                            <Text style={styles.textTitle}>{"Pagar con otra tarjeta"}</Text>
                                        </Col>
                                        <Col xs={1}>
                                            {
                                                desplegable ?
                                                    <MinusOutlined
                                                        style={styles.icon} />
                                                    :
                                                    <RightOutlined
                                                        style={styles.icon} />
                                            }
                                        </Col>
                                    </Row>
                                    {desplegable ? (
                                        <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
                                            <Col xs={24} xl={12}>
                                                <Text style={styles.inputTitle}>Número de Tarjeta</Text>
                                                <Input
                                                    value={numCardNew}
                                                    style={styles.inputText}
                                                    placeholder='0000 0000 0000 0000'
                                                    onChange={(element) => handleCardNumNew(element.target.value.replace(/[^0-9]/g, ''))}
                                                    status={errorsEmptyFields.creditCard ? "error" : ""}
                                                    maxLength={19}
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.creditCard ? errorsEmptyFields.creditCard : null}</Text>}
                                            </Col>
                                            <Col xs={24} xl={12}>
                                                <Text style={styles.inputTitle}>Vencimiento</Text>
                                                <Input
                                                    value={expCardNew.replace(/(\d{2})(\d{2})/, "$1/$2")}
                                                    style={styles.inputText}
                                                    placeholder='mm/aa'
                                                    onChange={(element) => handleCardExpNew(element.target.value)}
                                                    status={errorsEmptyFields.expirationCard ? "error" : ""}
                                                    maxLength={5}
                                                    suffix={
                                                        <Tooltip title={`Fecha de vencimiento: Fecha ubicada al frente de tu tarjeta, debajo del número de tarjeta.`} >
                                                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                        </Tooltip>
                                                    }
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.expirationCard ? errorsEmptyFields.expirationCard : null}</Text>}
                                            </Col>
                                            <Col xs={24} xl={12} style={{ display: 'flex', alignItems: 'center' }}>
                                                <div style={{ display: 'flex', justifyContent: 'space-evenly', flex: 1 }}>
                                                    <Text style={styles.saveCardText}>Guardar Tarjeta</Text>
                                                    <Switch checked={toSaveCard} onChange={onChange} />
                                                </div>
                                            </Col>

                                            <Col xs={24} xl={12}>
                                                <Text style={styles.inputTitle}>CVV</Text>
                                                <Input
                                                    value={cvvCardNew}
                                                    style={styles.inputText}
                                                    placeholder='000'
                                                    onChange={(element) => handleCardCvvNew(element.target.value)}
                                                    status={errorsEmptyFields.cvvCard ? "error" : ""}
                                                    maxLength={3}
                                                    suffix={
                                                        <Tooltip title={`CVV: Código de 3 dígitos, situado al reverso de tu tarjeta.`} >
                                                            <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                                        </Tooltip>
                                                    }
                                                />
                                                {<Text type="danger" style={styles.emptyFieldError}>{errorsEmptyFields.cvvCard ? errorsEmptyFields.cvvCard : null}</Text>}
                                            </Col>
                                            <Col xs={24} style={styles.colPayButton}>
                                                <Button
                                                    size='large'
                                                    style={styles.buttonPrimary}
                                                    onClick={validateData}
                                                >
                                                    {"Pagar con esta tarjeta"}
                                                    <RightOutlined />
                                                </Button>
                                            </Col>
                                        </Row>
                                    ) : null}
                                </Card>
                                :
                                null
                        }
                    </>
            }
            {
                confirmStep ?
                    <Card style={styles.cardView}>
                        <Button style={styles.buttonGoBackC}
                            type="primary"
                            onClick={() => setConfirmStep(false)}
                        >
                            <LeftOutlined />
                            <Text style={styles.goBackConfirm}>{"Regresar"}</Text>
                        </Button>
                        <Row style={styles.rowViewTitleC}>
                            <Col xs={20}>
                                <Text style={styles.textTitleSecond}>{"Confirmación de pago"}</Text>
                            </Col>
                            <Col xs={4}>
                                <img style={styles.imageStores} src={images.megaLogo} alt="Mega Logo" />
                            </Col>
                        </Row>
                        <Text style={{ fontWeight: 600 }}>¡Estimado usuario!</Text>
                        <Row gutter={[12, 12]} style={{ marginTop: 10 }}>
                            <Col xs={24} xl={15}>
                                <Text style={styles.inputTitle}>
                                    {"¿Desea realizar el pago de su contrato " + dataClient?.nombre + " " + dataClient?.sucursal + dataClient?.suscriptor + " con su tarjeta de crédito con terminación " + cardEnd + "?"}
                                </Text>

                            </Col>
                            <Col xs={24} xl={15}>
                                <Text style={styles.inputTermsAndC}>
                                    Para hacer el pago, favor de aceptar los términos y condiciones y deslizar el botón hacia la derecha
                                </Text>
                            </Col>

                            <Col xs={24} xl={13}>
                                <Link
                                    style={{ color: "#1d5092", textDecoration: 'underline' }}
                                    to={'https://www.megacable.com.mx/terminos-y-condiciones'}
                                    target='_blank'
                                >
                                    Términos y Condiciones.
                                </Link>
                            </Col>
                            <Col xs={24} xl={11} >
                                <div style={styles.rowViewTerms}>
                                    <Checkbox style={{ width: "20%" }} onChange={onChangeCheck} ></Checkbox>
                                    <Text style={styles.inputTermsAgree}>{"Estoy de acuerdo con los Términos y Condiciones de Uso"}</Text>
                                </div>
                            </Col>
                            <Col xs={24} style={styles.colSwipConfirm}>
                                <div style={{ width: "80%" }}>
                                    {
                                        checked ?
                                            <SwipeableButton
                                                onSuccess={() => doPayment(cardToPay)}
                                                color='#0055c2'
                                                text='Deslice para confirmar'
                                            />
                                            :
                                            <DisabledSwipeableButton color='gray' text='Deslice para confirmar' />
                                    }
                                </div>
                            </Col>
                        </Row>
                    </Card>
                    : null
            }
        </>
    );
};

const styles = StyleSheet.create({
    cardViewRoot: {
        backgroundColor: 'white',
        borderRadius: 15,
        marginBottom: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)"
    },
    cardView: {
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 15
    },
    cardViewPay: {
        cursor: 'pointer',
        backgroundColor: 'white',
        borderRadius: 15,
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
    },
    textTitleSecond: {
        fontSize: 15,
        color: "#00339D",
        fontWeight: 600,
    },
    textTitle: {
        fontSize: 15,
        color: "#767b81",
        fontWeight: 600,
    },
    rowViewTitleC: {
        display: 'flex',
        alignItems: 'center'
    },
    rowViewSecure: {
        display: 'flex',
        justifyContent: 'center'
    },
    rowViewTerms: {
        display: 'flex',
        justifyContent: 'space-between'
    },
    rowViewPaymentData: {
        marginTop: 10
    },
    colPayButton: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 10,
    },
    colSwipConfirm: {
        display: 'flex',
        justifyContent: 'center'
    },
    colCardNumber: {
        width: "100%",
        justifyContent: 'center',
        display: 'flex',
        marginTop: 10
    },
    goBackConfirm: {
        color: "white"
    },
    saveCardText: {
        color: "#767b81",
        fontWeight: 600,
    },
    icon: {
        fontSize: 15,
        color: "#767b81"
    },
    inputContainer: {
        width: "80%",
    },
    inputText: {
        marginTop: 10,
        color: "#000000",
        borderColor: '#000000',
        fontSize: 12
    },
    emptyFieldError: {
        fontSize: 11
    },
    inputTitle: {
        color: "#0055c2",
        fontWeight: 600,
        fontSize: 12
    },
    inputTermsAndC: {
        color: "black",
        fontWeight: 600,
        fontSize: 12
    },
    inputTermsAgree: {
        color: "black",
        fontSize: 10,
        width: "80%"
    },
    buttonPrimary: {
        backgroundColor: '#0055c2',
        borderRadius: 15,
        color: 'white',
        border: "none"
    },
    buttonGoBackC: {
        backgroundColor: '#00339D',
        borderRadius: 15,
        color: 'white',
        boxShadow: "3px 3px 5px 0px rgba(0,0,0,0.10)",
        marginBottom: 10
    },
    imageStores: {
        height: 50
    },
    imageSecure: {
        height: 50
    },
});

export default PaymentCardData;
